import { isMobile } from 'react-device-detect'
import * as Sentry from '@sentry/react'
import WalletConnectProvider from '@walletconnect/web3-provider'
import * as evmChains from 'evm-chains'
import Web3 from 'web3'
import { provider as web3provider } from 'web3-core'
import Web3Modal from 'web3modal'

import { dev } from './web3.config'

import type { AbstractProvider } from 'web3-core'

// const providerOptions = {
//   /* See Provider Options Section */
//   walletconnect: {
//     package: WalletConnectProvider, // required
//     // options: {
//     //   infuraId: 'INFURA_ID', // required
//     // },
//   },
// }

const providerOptions = {
  walletconnect: {
    package: WalletConnectProvider,
    options: {
      rpc: {
        2415: 'https://xo-dex.io',
      },
    },
  },
}

export const web3Modal = new Web3Modal({
  // network: 'mainnet', // optional
  cacheProvider: true, // optional
  providerOptions, // required
})

// TODO write test
export async function switchNetwork(web3: Web3) {
  const provider = web3.currentProvider as AbstractProvider

  const addChain = async () => {
    await provider.request?.({
      method: 'wallet_addEthereumChain',
      params: [
        {
          chainName: 'XODEX',
          chainId: '0x96F',
          nativeCurrency: {
            name: 'XODEX',
            decimals: 18,
            symbol: 'XODEX',
          },
          rpcUrls: ['https://mainnet.xo-dex.com/rpc'],
          iconUrls: ['http://xo-dex.com/assets/images/xodexcircle.png'],
          blockExplorerUrls: ['https://explorer.xo-dex.com'],
        },
      ],
    })
  }

  const addNetwork = async () => {
    const chainId = 2415

    if (!window.ethereum || !provider) {
      return
    }

    if (window.ethereum.networkVersion !== chainId) {
      try {
        await provider.request?.({
          method: 'wallet_switchEthereumChain',
          params: [{ chainId: '0x96F' }],
        })
      } catch (err: any) {
        // This error code indicates that the chain has not been added to MetaMask

        try {
          if (isMobile) {
            const errorCode = err.data?.originalError?.code
            if (errorCode && errorCode === 4902) {
              await addChain()
            }
          } else {
            // eslint-disable-next-line no-lonely-if
            if (err.code === 4902) {
              await addChain()
            }
          }
        } catch (error) {
          console.error(error)
          Sentry.captureException(err)
        }

        console.error(err)
        Sentry.captureException(err)
      }
    }
  }

  addNetwork()
}

function makeRequest(method: string, url: string) {
  // eslint-disable-next-line compat/compat
  return new Promise<any>(function (resolve, reject) {
    //TODO change any promise type
    const xhr = new XMLHttpRequest()
    xhr.open(method, url)
    xhr.onload = function () {
      if (this.status >= 200 && this.status < 300) {
        resolve({
          status: this.status,
          statusText: xhr.response,
        })
      } else {
        reject({
          status: this.status,
          statusText: xhr.statusText,
        })
      }
    }
    xhr.onerror = function () {
      reject({
        status: this.status,
        statusText: xhr.statusText,
      })
    }
    xhr.send()
  })
}

export async function fetchAccountData(provider: web3provider) {
  // Get a Web3 instance for the wallet
  const web3 = new Web3(provider)
  console.log('provider', provider)

  console.log('Web3 instance is', web3)

  // Get connected chain id from Ethereum node
  const chainId = await web3.eth.getChainId()
  // Load chain information over an HTTP API
  // const chainData = evmChains.getChain(chainId)
  // console.log(chainData.name)

  // Get list of accounts of the connected wallet
  const accounts = await web3.eth.getAccounts()

  // MetaMask does not give you all accounts, only the selected account
  console.log('Got accounts', accounts)
  return accounts[0]
}
